export default class PollingService {
    private interval?: any;
    private isRunning: boolean = false;

    constructor() {
        this.interval = null;
    }

    startPoll(pollFunc: () => void, interval: number) {
        if(this.isRunning) return;
        this.isRunning = true;
        this.interval = setInterval(pollFunc, interval)
    }

    stopPoll() {
        this.isRunning = false;
        clearInterval(this.interval);
    }

    getIsRunning() : boolean {
        return this.isRunning;
    }
}